import { Options as IRichTextOptions } from "@contentful/rich-text-react-renderer"
import {
  ContentfulRichTextGatsbyReference,
  renderRichText,
  RenderRichTextData,
} from "gatsby-source-contentful/rich-text"
import React from "react"
import styled, { css } from "styled-components"
import { FontFamilyRegular } from "../../components/shared/typography.styles"
import { T } from "../styles/typography"
import mergeOptions from "../util/merge-options"
import mergeVariants, { TVariantProp } from "../util/merge-variants"
import { DefaultRichTextOptions } from "./rich-text/rich-text"
import VariantContainer from "./variant-container"

interface ITextElement extends React.HTMLAttributes<HTMLParagraphElement> {
  as?: React.ElementType | keyof JSX.IntrinsicElements | string
  className?: string
  children?: React.ReactNode
  variants?: TVariantProp
}

const TextElement = styled(VariantContainer)`
  ${FontFamilyRegular};
`

const Text = ({
  as = "p",
  className,
  children,
  variants,
  ...rest
}: ITextElement) => {
  return (
    <TextElement
      as={as}
      className={className}
      variants={mergeVariants(variants, [])}
      {...rest}
    >
      {children}
    </TextElement>
  )
}

Text.Body = ({ variants, children, className, ...rest }: ITextElement) => (
  <Text
    className={className}
    variants={mergeVariants(
      {
        sm: css`
          //@ts-ignore
          ${T.sm.body`400`};
          color: var(--body-text-grey);
        `,
        //@ts-ignore
        md: T.md.body`400`,
        //@ts-ignore
        lg: T.lg.body`400`,
      },
      variants
    )}
    {...rest}
  >
    {children}
  </Text>
)

export interface IRichTextProps {
  children?: RenderRichTextData<ContentfulRichTextGatsbyReference>
  options?: IRichTextOptions
}

/**
 * Maps a Contentful RichText object to JSX components.
 *
 * @param children Rich text object from Contentful
 * @param options Override options for rich text elements
 * @returns Mapped JSX elements
 */
const RichText = ({ children, options }: IRichTextProps) => {
  return (
    <>
      {children
        ? renderRichText(
            children,
            mergeOptions(DefaultRichTextOptions, options)
          )
        : ""}
    </>
  )
}

export { T, Text, RichText }

export default Text
